<template>
<div class="wheader">
    <div class="header">
            <img class="logo" src="../assets/images/mobiigw/logo.png" alt="">
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" router>
                <el-menu-item class="a" index="home">首页</el-menu-item>
                <el-menu-item class="a" index="aboutus">关于我们</el-menu-item>
                <el-menu-item class="a" index="contactus">联系我们</el-menu-item>
            </el-menu>
    </div>
</div>
    
</template>
<script>
export default {
    data(){
        return{
            // activeIndex: "home" //当前所激活菜单的 index
        }
    },
    watch:{
        $route(){
            this.setCurrentRoute()
        }
    },
    methods:{
        handleSelect(){},
        setCurrentRoute(){
            this.activeIndex = this.$route.name; //通过其监听当前路由状态并激活当前菜单
        }
    },
    created(){
        this.setCurrentRoute()
    }
}
</script>
<style scoped>
.wheader{
    height: 60px;
    min-width: 1280px;
}

.header{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 60px;
    width: 71.11%;
    padding: 0;
    margin: 0 auto;
}

.logo{
    height: 32px;
    margin-top: 20px;
    }

.el-menu{
    border-bottom: none;
    width: 20%;
}

.el-menu-demo{
    font-size:20px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(66,57,74,1);
    line-height:28px;
    width: 30%;
}

.el-menu-item{
    border-bottom: rgba(253,95,0,1);
}

.el-menu-item.is-active {
    color: rgba(253,95,0,1) !important;
}

.el-menu--horizontal>.el-menu-item.is-active{
    border-bottom: 2px solid rgba(253,95,0,1) ;
}
</style>


// WEBPACK FOOTER //
// src/modules/topnav.vue